import React from "react";
import { getBackgroundColor, getTextColour } from "utils";
import PropTypes from "prop-types";

const Gradient = ({ content, maxOccurrences }) => (
  <span
    className="gradient"
    style={{
      backgroundColor:
        content > 0
          ? getBackgroundColor(maxOccurrences, 0, content)
          : "transparent",
      color: getTextColour(maxOccurrences, 0, content),
    }}
    data-testid="gradient"
  >
    {content > 0 ? content.toLocaleString() : ""}
  </span>
);

export default Gradient;

Gradient.propTypes = {
  content: PropTypes.number,
  maxOccurrences: PropTypes.number,
};
